export const CODE_OLD = {
  success: '00000000',
  '00000000': 'OK',
  900170: '未登录',
  99999999: '未知错误',
  900215: 'rpc错误',
  900212: 'db错误',
  900214: '缓存错误',
  900217: '搜索错误',
  555555: '服务器错误',
  // unlogin: '900170',
  // unknowError: '99999999',
  // rpcError: '900215',
  // dbError: '900212',
  // cacheError: '900214',
  // searchError: '900217',
  // serviceError: '555555',
};

export const CODE = {
  success: 'OK',
  authFailed: 'AuthFailed',
  OK: '成功',
  Internal: '内部错误',
  ApiNotExists: 'API不存在',
  Expired: '超时',
  AuthFailed: '登录失效，请重新登录',
  ServerUnauthorized: '服务器未授权',
  FieldLost: '字段缺失',
  AuthConnectBizInvalid: '外部登录商户非法',
  ExchageRateInvalid: '外汇的汇率无效',
  PayRequestAmtInvalid: '外部支付请求金额非法',
  PayRequestTranscationInvalid: '外部支付的单号非法',
  PayRequestRejected: '外部支付的被拒付',
  PayRequestCurInvalid: '外部支付请求币种非法',
  PayRequestUrlInvalid: '外部支付请求地址不正确',
  PayRequestPayeeInvalid: '外部支付请求收款人非法',
  PwdInvalid: '密码非法',
  InvalidCountry: '国家非法',
  InvalidPath: '路径非法',
  InvalidPwd: '无效的密码',
  InvalidBizPwd: '无效的资金密码',
  InvalidUser: '用户非法',
  InvalidSubacct: '无效的子帐户',
  InvalidSign: '无效的签名',
  InvalidCur: '无效的币种',
  InvalidParameter: '无效的参数',
  InvalidBase64String: '无效的Base64字符串',
  NickNameEmpty: '必填的昵称为空',
  InvalidInstrument: '无效交易品种',
  ExceedQuoteAllowance: '报价超出允许的范围',
  ExceedOfferLimitCount: '发布供求过多，超过允许次数',
  VericodeFrequent: '手机验证码发送过于频繁',
  SendNoticeError: '发送手机或邮件通知失败',
  VericodeInvalid: '验证码非法',
  OtcCreateOfferInvalidBS: 'OTC创建信息时买卖方向非法',
  OtcCreateOfferInvalidOfferRange: 'OTC创建信息时提供范围非法',
  OtcCreateOfferInvalidPremiumPctg: 'OTC创建信息时浮动百分比非法',
  OtcOfferInsufficiency: 'OTC创建信息时可用额不足',
  OtcResponseAmtInvalid: 'OTC回应金额非法',
  OtcResponseSelf: 'OTC回应，不得与自己交易',
  OtcOfferInvalid: 'OTC供求信息非法',
  OtcResponseInvalid: 'OTC回应信息非法',
  OtcOfferStatusAbnormal: 'OTC供求信息状态异常',
  OtcProceedResponceInvalid: 'OTC处理响应非法',
  OtcProceedOperationInvalid: 'OTC处理操作非法',
  OtcProceedPaymentInvalid: 'OTC处理支付方式非法',
  OtcOfferWithUnClearResponse: 'OTC供求还有未清理的响应',
  PaymentInvalid: '支付方式非法',
  PayFprStatusInvalid: '外部支付请求状态非法',
  PayPayeeInvalid: '支付收款人非法',
  PayPayerInvalid: '支付付款人非法',
  PayPayerUnauthorized: '支付付款人未授权',
  PayCurInvalid: '支付货币非法',
  PayAmtInvalid: '支付金额非法',
  PayInsufficientFund: '支付可用资金不足',
  TradeInstrumentInvalid: '交易品种非法',
  TradeInstrumentNotOn: '交易品种处于不可交易状态',
  TradeAcctInvalid: '交易账户非法',
  TradeTicketInvalid: '交易单非法',
  TradeQtyInvalid: '交易大小非法',
  TradePendingPriceInvalid: '交易挂单价格非法',
  TradePendingStopLossInvalid: '交易挂单S/L非法',
  TradePendingTakeProfitInvalid: '交易挂单T/P非法',
  TradeMarketOpenStopLossInvalid: '交易市价单S/L非法',
  TradeMarketOpenTakeProfitInvalid: '交易市价单T/P非法',
  TradeTickingOudated: '交易ticking过期',
  UserExists: '用户已存在',
  AddressExists: '地址已存在',
  AddressNotExists: '地址不存在',
  CurCodeExists: '币种已存在',
  UnauthorizedBiz: '未得到商户授权',
  UnauthorizedPartner: '未得到合作伙伴授权',
  UserSetPaymentBizInvalid: '用户设置支付方式时，支付商户非法',
  UserStatusAbnormal: '用户状态异常',
  BadAddress: '地址不正确',
  WithdrawInsufficiency: '提币余额不足',
  InvalidExpiry: '截止时间无效',
  InvalidCallbackUrl: '无效的回调Url地址',
  BindTelExist: '用户已绑定手机号码',
  BindMailExist: '用户已绑定邮箱',
  BindTelNotExist: '用户不存在已绑定手机号码',
  BindMailNotExist: '用户不存在已绑定邮箱',
  SessionNotExist: '用户Session不存在',
  PayTimeout: '支付超时，已超15分钟',
  AixinfPayNoSet: '惠民支付参数未设置',
  InvalidTransactionType: '无效的交易类型',
  VericodeSendError: '手机验证码发送失败',
  OtcAnswerAmtInvalid: 'OTC回应金额非法',
  OtcAnswerSelf: 'OTC回应，不得与自己交易',
};



// WEBPACK FOOTER //
// ./src/api/config/xhr.js